import React ,{useEffect}from "react";

const RefundAndCancellationPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Refund & Cancellation Policy</h1>
      <p>
        Please read our refund and cancellation terms carefully before placing
        an order with Sri Mangalambika Storess.
      </p>

      {/* Cancellation Policy */}
      <section style={{ marginTop: "30px" }}>
        <h2>Order Cancellation Policy</h2>
        <p>
          Orders can be cancelled within <strong>24 hours</strong> of placement,
          provided they have not been dispatched.
        </p>
        <ul>
          <li>Once shipped, orders cannot be cancelled.</li>
          <li>
            To cancel an order, please email us at{" "}
            <a href="mailto:srimangalambikastore@gmail.com">
              srimangalambikastore@gmail.com
            </a>{" "}
            or contact our customer care.
          </li>
          <li>
            Refunds for cancelled orders will be processed within 7–10 working
            days to your original payment method.
          </li>
        </ul>
      </section>

      {/* Refund Policy */}
      <section style={{ marginTop: "30px" }}>
        <h2>Refund & Return Policy</h2>
        <p>We offer refunds only in the following cases:</p>
        <ul>
          <li>Incorrect product delivered.</li>
          <li>
            Damaged product (must notify within{" "}
            <strong>48 hours of delivery</strong> with images).
          </li>
        </ul>
        <p>
          Refunds will be initiated after verification and will be credited to
          your original payment method within <strong>7–10 working days</strong>
          .
        </p>

        <h4>Non-Returnable Items:</h4>
        <ul>
          <li>Customized or personalized products.</li>
          <li>Fragile brass idols and delicate decor.</li>
          <li>Used or opened items.</li>
        </ul>

        <h4>Exchange Policy:</h4>
        <p>
          Exchanges are allowed only for defective items after review by our
          quality team.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h3>For assistance:</h3>
        <p>
          Email:{" "}
          <a href="mailto:srimangalambikastore@gmail.com">
            srimangalambikastore@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
};

export default RefundAndCancellationPolicy;
